import React, { FC, SetStateAction, createContext, useContext, useState } from "react";
import { WithChildren } from "../../../_metronic/helpers";

type PhanHeDieuTriContextProps = {
    benhNhanDieuTri: any;
    setBenhNhanDieuTri: React.Dispatch<SetStateAction<any>>;
}

const initState = {
    benhNhanDieuTri: {},
    setBenhNhanDieuTri: () => { },
}

export const PhanHeDieuTriContext = createContext<PhanHeDieuTriContextProps>(initState);

export const PhanHeDieuTriProvider: FC<WithChildren> = ({ children }) => {
    const [benhNhanDieuTri, setBenhNhanDieuTri] = useState<any>({});
    const value = { benhNhanDieuTri, setBenhNhanDieuTri };
    return (
        <PhanHeDieuTriContext.Provider value={value}>
            {children}
        </PhanHeDieuTriContext.Provider>
    )
}
export default PhanHeDieuTriProvider;

export const usePhanHeDieuTriNoiTruContext = () => useContext(PhanHeDieuTriContext);
